/*
 * Copyright (c) 2022 Robert J Whelton. All rights reserved.
 */
import BLAKE2s from "blake2s-js"

function hash(string) {
  const h = new BLAKE2s(32)
  h.update(new TextEncoder().encode(string))
  return h.hexDigest()
}

export const isBrowser = () => typeof window !== "undefined"

export const getUser = () =>
  isBrowser() && localStorage.getItem("gatsbyUser")
    ? JSON.parse(localStorage.getItem("gatsbyUser"))
    : {}

const setUser = user => localStorage.setItem("gatsbyUser", JSON.stringify(user))

export const handleLogin = ({ username, password}) => {
  if (
    hash(username) === '67804f7b50f59148324f23ffbf44c59ff73bb938f4059c8d9b69cd3c83e0b85c'
    && hash(password) === 'fe710c747887d15ecad2c435fc77d14d8bb6e0875ac46040c89fb0a3de6acb86'
  ) {
    setUser({
      username: `robert`,
      name: `Mnemicon the Mnemonicator`,
      role: 'Creative security engineer'
    })
    return true
  }

  return false
}

export const isLoggedIn = () => {
  const user = getUser()

  return !!user.username
}

export const logout = callback => {
  setUser({})
  callback()
}
